import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import MoreHoriz from "@mui/icons-material/MoreHoriz";

/**
 * MemberMenu
 * 各メンバー行に表示される 3点メニューコンポーネント。
 * 「スキルシート」「編集」「削除」「登録メール送信」のアクションをまとめて提供する。
 */

export default function MemberMenu({
  user,
  currentCompanyUser,
  onDetail,
  onEdit,
  onDelete,
  onSendRegisterMail,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  // Menu が開いているかどうか
  const open = Boolean(anchorEl);

  // 権限判定
  const isAdmin = currentCompanyUser?.role === "admin";
  const isGeneral = currentCompanyUser?.role === "general";
  const isManagerOfTargetUser = user.manager_id === currentCompanyUser?.id;

  const canEditUser = isAdmin || (isGeneral && isManagerOfTargetUser);
  const canDeleteUser = isAdmin;

  // 管理者は全員閲覧可能
  // 担当者(general)は自分の担当のみスキルシート操作可能
  const canOpenSkillSheet = isAdmin || (isGeneral && isManagerOfTargetUser);

  // スキルシート作成済み判定
  const hasSkillSheet = Boolean(user.skill_sheet_flag);

  const skillSheetLabel = hasSkillSheet
    ? "スキルシートを見る"
    : "スキルシートを編集する";

  // メールアドレスが登録されているか
  const hasEmail = Boolean(user.email);

  // メンバーが削除されているか
  const isDeleted = Boolean(user.deleted_at);

  return (
    <>
      {/* 3点ボタン */}
      <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
        <MoreHoriz fontSize="small" />
      </IconButton>

      {/* ドロップダウンメニュー */}
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {/* スキルシート詳細メニュー */}
        {hasSkillSheet ? (
        // 作成済み → 全員閲覧OK
        <MenuItem onClick={() => {
          onDetail(user);
          setAnchorEl(null);
        }}>
          {skillSheetLabel}
        </MenuItem>
      ) : canOpenSkillSheet ? (
        // 未作成だけど担当者 → 編集OK
        <MenuItem onClick={() => {
          onDetail(user);
          setAnchorEl(null);
        }}>
          {skillSheetLabel}
        </MenuItem>
      ) : (
        // 未作成 & 担当者じゃない → NG（閲覧も編集もできない）
        <Tooltip title="担当者しか編集できません" placement="top">
          <span>
            <MenuItem disabled>
              {skillSheetLabel}
            </MenuItem>
          </span>
        </Tooltip>
      )}

        {/* 編集：権限があるユーザーのみ */}
        {canEditUser && (
          <MenuItem
            onClick={() => {
              onEdit(user);
              setAnchorEl(null);
            }}
          >
            メンバー情報を編集する
          </MenuItem>
        )}

        {isDeleted ? (
          <MenuItem
            onClick={() => {
              console.log("復元（仮）", user);
              setAnchorEl(null);
            }}
          >
            メンバーを復元する
          </MenuItem>
        ) : (
          <Tooltip title={!hasEmail ? "メールアドレスが未設定です" : ""} placement="top">
            <span>
              <MenuItem
                disabled={!hasEmail}
                onClick={() => {
                  if (!hasEmail) return;
                  onSendRegisterMail(user);
                  setAnchorEl(null);
                }}
              >
                登録メールを送る
              </MenuItem>
            </span>
          </Tooltip>
        )}

        {canDeleteUser && !isDeleted && (
          <MenuItem
            onClick={() => {
              onDelete(user);
              setAnchorEl(null);
            }}
            sx={{ color: "error.main" }}
          >
            メンバーを削除する
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
